import superagent from 'superagent';
import { backendUrl } from '@helpers/consts';

class AutomationApi {
  constructor() {
    this.baseUrl = `${backendUrl}/automation`;
  }

  getAuthHeaders() {
    return {
      'Authorization': `Bearer ${localStorage.getItem("authJWT")}`,
      'Accept': 'application/json'
    };
  }

  _buildQuery(params = {}) {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== undefined && v !== null && v !== '')
    );
    const qs = new URLSearchParams(filtered).toString();
    return qs ? `?${qs}` : '';
  }

  // ==================== RULES ====================

  async getRules(params = {}) {
    const response = await superagent
      .get(`${this.baseUrl}/rules${this._buildQuery(params)}`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  async getRule(id) {
    const response = await superagent
      .get(`${this.baseUrl}/rules/${id}`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  async createRule(data) {
    const response = await superagent
      .post(`${this.baseUrl}/rules`)
      .send(data)
      .set(this.getAuthHeaders());
    return response.body;
  }

  async updateRule(id, data) {
    const response = await superagent
      .put(`${this.baseUrl}/rules/${id}`)
      .send(data)
      .set(this.getAuthHeaders());
    return response.body;
  }

  async deleteRule(id) {
    await superagent
      .delete(`${this.baseUrl}/rules/${id}`)
      .set(this.getAuthHeaders());
  }

  async toggleRule(id) {
    const response = await superagent
      .post(`${this.baseUrl}/rules/${id}/toggle`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  async executeRule(id) {
    const response = await superagent
      .post(`${this.baseUrl}/rules/${id}/execute`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  // ==================== VERSIONS ====================

  async getWorkflowVersions(workflowId) {
    const response = await superagent
      .get(`${this.baseUrl}/rules/workflows/${workflowId}/versions`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  // ==================== STATS ====================

  async getStats() {
    const response = await superagent
      .get(`${this.baseUrl}/stats`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  // ==================== METADATA ====================

  async getEventTypes() {
    const response = await superagent
      .get(`${this.baseUrl}/events`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  async getActionTypes() {
    const response = await superagent
      .get(`${this.baseUrl}/actions`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  async getFields(entityType) {
    const url = entityType
      ? `${this.baseUrl}/fields/${entityType}`
      : `${this.baseUrl}/fields`;
    const response = await superagent
      .get(url)
      .set(this.getAuthHeaders());
    return response.body;
  }

  // ==================== DYNAMIC SELECT OPTIONS ====================

  async getFlagTypes() {
    const response = await superagent
      .get(`${backendUrl}/orders/getFlagTypes`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  async getRulesForSelect() {
    const response = await superagent
      .get(`${this.baseUrl}/rules?perPage=100`)
      .set(this.getAuthHeaders());
    const body = response.body;
    return Array.isArray(body) ? body : body?.data || [];
  }

  // ==================== EXECUTIONS ====================

  async getExecutions(params = {}) {
    const response = await superagent
      .get(`${this.baseUrl}/executions${this._buildQuery(params)}`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  async getExecution(id) {
    const response = await superagent
      .get(`${this.baseUrl}/executions/${id}`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  async retryExecution(id) {
    const response = await superagent
      .post(`${this.baseUrl}/executions/${id}/retry`)
      .set(this.getAuthHeaders());
    return response.body;
  }
}

export default new AutomationApi();
